import { Injectable } from "@angular/core";

@Injectable()
export class HumanizeService {
  transform(input: string | number): string {
    if (input === "" || typeof input === "undefined") {
      return "";
    }

    // Capitalize first letter
    // Replace underscores with space
    let output = input
      .toString()
      .trim()
      .toLowerCase()
      .replace("_", " ")
      .split("");

    output[0] = output[0].toUpperCase();

    return output.join("");
  }
}
